import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { loadPrenotationList, updatePage } from "../../redux/reducer/prenotationReducer";
import { useAppDispatch } from "../../redux/";
import BoxNullItems from "../boxNullItems";
import Pagination from "../pagination"
import PrenotationRow from "./prenotationRow"
import TableHeader from "./prenotationRowHeader"
import PrenotationListCalendar from "./prenotationListCalendar";
import PopUpViewPrenotationByTimeslot from "../popUpViewPrenotationByTimeslot";
import moment from "moment";
import PopUpNote from "../popUpNote";

const PrenotationTable = () => {
  const { list, countListAll, page } = useSelector((state: any) => state.prenotation);
  let result: any[] = list.filter((prenotation: any) => prenotation?.bookingId !== "");
  const [showPopUpViewPrenotationByTimeslot, setShowPopUpViewPrenotationByTimeslot] = useState(false);
  const [selectTimeslot, setSelectTimeslot] = useState("");
  const [bookingId, setBookingId] = useState("");
  const pageList: number = Number(process.env.REACT_APP_PAGE_LIST) || 10;
  const { filterType } = useSelector((state: any) => state.timeslot);
  let pageTotal = Math.ceil(Number(countListAll) / pageList);
  const dispatch = useAppDispatch();
  const [pageIndex, setPageIndex] = useState(1);
  const [selectedDay, setSelectedDay] = useState("");
  const [showPopUpNote, setShowPopUpNote] = useState(false);
  const [attendanceFullName, setAttendanceFullName] = useState("");

  useEffect(() => {
    dispatch(updatePage(pageIndex));
    dispatch(loadPrenotationList());
  }, [pageIndex]);

  useEffect(() => {
    setPageIndex(page);
  }, [page]);

  // useEffect(() => {
  //   dispatch(loadListCalendar());
  // }, [])

  const openPopUpViewPrenotationByTimeslot = (bookingId: any, timeslot: any) => {
    setSelectedDay(moment(timeslot.startDate).format('YYYY-MM-DD'));
    setSelectTimeslot(timeslot._id);
    setBookingId(bookingId)
    setShowPopUpViewPrenotationByTimeslot(true);
  }

  const closePopUpNote = () => {
    setBookingId("");
    setAttendanceFullName("");
    setShowPopUpNote(false)
  }
  const openPopUpNote = (booking: string, attendanceFullName: string) => {
    setBookingId(booking);
    setAttendanceFullName(attendanceFullName);
    setShowPopUpNote(true);
  }
  return (
    <>
      <div className="row m-0">
        <div className="col-lg-12">
          <div className="Section">
            {((filterType == "list") ?
              <>
                <table className="table">
                  <TableHeader />
                  <PrenotationRow openPopUpNote={openPopUpNote} openPopUpViewPrenotationByTimeslot={openPopUpViewPrenotationByTimeslot} prenotation={result} />
                </table>
                {result.length !== 0 &&
                  <>
                    <Pagination
                      onPageChange={setPageIndex}
                      pageIndex={pageIndex}
                      pageTotal={pageTotal}
                    />
                  </>
                }
                {showPopUpViewPrenotationByTimeslot && <PopUpViewPrenotationByTimeslot
                  selectedDay={selectedDay}
                  selectedTimeslotId={selectTimeslot}
                  selectedBookingId={bookingId}
                  closePopUp={() => setShowPopUpViewPrenotationByTimeslot(false)}
                />}
                {result.length === 0 &&
                  <BoxNullItems icon="list" label={t('not-prennotations')} />
                }

              </>
              :

              <PrenotationListCalendar />
            )}
          </div>
        </div>
      </div>
      <PopUpNote bookingId={bookingId} attendanceFullName={attendanceFullName} show={showPopUpNote} closePopUp={() => (closePopUpNote())} />
    </>


  )
}

export default PrenotationTable

